module.exports = __webpack_public_path__ + "img/Group 28013@2x.a89a89f5.png";